module.exports = "<h2>Page not found</h2>\n<span class=\"col-md-12 col-xs-12 mb40\">\n</span>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/misc/page-not-found/page-not-found.component.html
// module id = ./src/app/misc/page-not-found/page-not-found.component.html
// module chunks = main